$(document).ready(function () {
  // Enable This for Play Button Functionaly
  $('#player-v2').on('click', function () {
    $(this).hide();
    $('#about-v2-video').attr({ controls: '', autoplay: '', playsinline: '' });
    $('#about-v2-video').get(0).play();
  });
});
